import { render } from "./ExerciceImageToWords.vue?vue&type=template&id=19a76832&scoped=true"
import script from "./ExerciceImageToWords.vue?vue&type=script&lang=js"
export * from "./ExerciceImageToWords.vue?vue&type=script&lang=js"

import "./ExerciceImageToWords.vue?vue&type=style&index=0&id=19a76832&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-19a76832"

export default script